
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'Play'
})
export default class Play extends Vue {}
